import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from "./pages/Home Page/HomePage";
import PersonalProjectsPage from "./pages/PersonalProjects/PersonalProjects";
import WorkPage from "./pages/Work/Work";
import ProjectDescriptionPage from "./pages/ProjectDescription Page/ProjectDescriptionPage";
import Page404 from "./pages/Page404/Page404";
import BlogPage from "./pages/Blog Page/BlogPage";
import BlogPostPage from "./pages/Blog Page/BlogPostPage";
import WebGPUIntro from "./pages/webgpu_intro";
import CarNeural from "./pages/CarNeural";
import SpaceInvaders from "./pages/SpaceInvaders";
export default function AppRoutes(props: { handlePage: (currentPage: string) => void }) {

    const { handlePage } = props;



    return (
        <Routes>
            <Route
                path="/"
                element={
                    <HomePage handlePage={handlePage} />
                }
            />
            <Route
                path="personal_projects"
                element={
                    <PersonalProjectsPage handlePage={handlePage} />
                }
            />
            <Route path='work' element={<WorkPage handlePage={handlePage} />} />

            {/* <Route
                path="studies"
                element={
                    <StudiesPage />
                }
            /> */}
            <Route path="personal_projects/webgpu_gameoflife" element={<WebGPUIntro />} />
            <Route path="blog" element={<BlogPage handlePage={handlePage} />} />
            <Route path="blog/post/:postId" element={<BlogPostPage handlePage={handlePage} />} />
            <Route path="/ai_projects/car_neural_network" element={<CarNeural />} />
            <Route path="/games/space_invaders" element={<SpaceInvaders />} />
            <></>

            <Route
                path="/:arr_handle/:project_handle"
                element={
                    <ProjectDescriptionPage
                        handlePage={handlePage}
                    />
                }
            />
            <Route path="404" element={<Page404 handlePage={handlePage} />} />
            <Route path="*" element={<Navigate replace={true} to="404" />} />
        </Routes>
    )
}

